// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"44b6a498","952":"bbe5f863"}[chunkId] + ".chunk.js";
};